'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import round from 'lodash/round';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { SimplifyJotTitleType } from '@/types/job-title';
import { trackClickEvent } from '@/utils/site-track';
import { numberRound } from '@/utils/numbers';

type Props = {
  dataEleGroup?: string;
} & SimplifyJotTitleType;

const JobTitleCard = ({
  id,
  name,
  salary_details: { min, max, avg },
  job_open_details: {
    new_job_details: { by_month: openJobDetailsByMonth = [] },
  },
  dataEleGroup = 'card_职场薪酬',
}: Props) => {
  const router = useRouter();

  const url = `${JOB_TITLE_PAGE_ROUTER_PATH}${id}/`;
  const dataEleId = `${id}_${name}`;
  const lastMonth = openJobDetailsByMonth[openJobDetailsByMonth.length - 1];

  return (
    <li
      className="rounded-lg border border-web-grey-750 shadow-4xl cursor-pointer overflow-hidden px-6 py-5 text-xs group hover:border-web-blue-500"
      onClick={(e) => {
        trackClickEvent(e);
        router.push(`${JOB_TITLE_PAGE_ROUTER_PATH}${id}/`);
      }}
      data-observer-id={id}
      data-ele-group={dataEleGroup}
      data-ele-id={dataEleId}
    >
      <Link
        href={url}
        title={name}
        onClick={(e) => trackClickEvent(e, true)}
        className="font-semibold line-clamp-1 text-base group-hover:text-web-blue-500"
        data-ele-group={dataEleGroup}
        data-ele-id={`${dataEleId}_link`}
      >
        {name}
      </Link>
      <p className="mt-2 flex items-center">
        平均薪资&nbsp;
        <span className="text-web-blue-500 text-lg leading-6">
          ¥{round(avg || 0, -2)}
        </span>
        &nbsp;<span className="text-web-grey-550">/月</span>
      </p>
      <p className="text-web-grey-550 mt-1.5 mb-3">
        月薪范围 {numberRound(min || 0)} - {numberRound(max || 0)}
      </p>
      <p className="text-web-grey-600 pt-2 border-t border-web-grey-100">
        {Number(lastMonth?.name.split('-')[1] || '')} 月新增岗位{' '}
        {lastMonth?.value || 0} 个
      </p>
    </li>
  );
};
export default JobTitleCard;
